import {
  Text,
  IconXMark,
  GreyGrey20,
  GreyGrey30,
  GreyGrey60,
  GreyGrey70,
  GreyGrey80,
  Primary12Regular,
  ShadowXs,
  Box,
  Flex
} from '@sequencehq/core-components'

interface Props {
  filename: string
  size: string
  type: 'PDF' | 'DOCX' | 'XLSX' | 'PNG' | 'JPG'
}

export const ChatFileAttachment = ({ filename, type }: Props) => {
  return (
    <Flex
      height="32px"
      padding="4px"
      borderRadius="6px"
      border="1px solid"
      borderColor={GreyGrey30}
      boxShadow={ShadowXs}
      backgroundColor="white"
      gap="8px"
      alignContent="center"
      alignItems="center"
    >
      <Box backgroundColor={GreyGrey20} borderRadius="4px" padding="4px 6px">
        <Text {...Primary12Regular} color={GreyGrey70} fontWeight="semibold">
          {type}
        </Text>
      </Box>
      <Text {...Primary12Regular} color={GreyGrey80} fontWeight="semibold">
        {filename}
      </Text>
      <Box
        borderRadius="4px"
        padding="4px 6px"
        cursor="pointer"
        _hover={{ backgroundColor: GreyGrey20 }}
      >
        <IconXMark color={GreyGrey60} />
      </Box>
    </Flex>
  )
}
